export const TABLECOLUMN = [
  {
    label: '货主编码',
    prop: 'code',
    width: 180,
    formatter: (row) => row.customerInfo?.customerCode || '--',
  },
  {
    label: '企业名称',
    prop: 'name',
    width: 180,
  },
  {
    label: '联系人信息',
    prop: 'info',
    width: 180,
    formatter: (row) => `${row.customerInfo?.contacts || ''} ${row.customerInfo?.telPhone || ''}`,
  },
  {
    label: '联系人地址',
    prop: 'address',
    width: 220,
    formatter: (row) => `${row.customerInfo?.provinceName || ''}${row.customerInfo?.cityName || ''}${row.customerInfo?.countyName || ''}${row.customerInfo?.address || ''}`,
  },
];

export const BINDTYPE = {
  NONE: 'NONE',
  PARENT: 'PARENT',
  CHILDREN: 'CHILDREN',
};

export const TYPE = 'ORG';

export const STATUS = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
};
